export default __webpack_public_path__ + "static/media/barcodeScanner.3423aeef.svg";